import { render, staticRenderFns } from "./PushButtonMock.vue?vue&type=template&id=487a7904&scoped=true&"
import script from "./PushButtonMock.vue?vue&type=script&lang=ts&"
export * from "./PushButtonMock.vue?vue&type=script&lang=ts&"
import style0 from "./PushButtonMock.vue?vue&type=style&index=0&id=487a7904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a7904",
  null
  
)

export default component.exports